import { withPrefix } from 'gatsby'
import React from 'react'

const listCardItems = [
  {
    scrollToSectionText: 'ahorroYa-register-section',
    ahorroYaSectionBtnText: 'Regístrate al programa',
    text: 'Regístrate al programa',
    image: {
      src: '/images/prima-productos/ahorroYa-banner-pig-icon.svg',
      alt: 'Regístrate al programa'
    }
  },
  {
    scrollToSectionText: 'ahorroYa-how-to-use-section',
    ahorroYaSectionBtnText: '¿Cómo utilizo el programa?',
    text: '¿Cómo utilizo el programa?',
    image: {
      src: '/images/prima-productos/ahorroYa-banner-phone-icon.svg',
      alt: '¿Cómo utilizo el programa?'
    }
  },
  {
    scrollToSectionText: 'ahorroYa-partners-section',
    ahorroYaSectionBtnText: 'Nuestros aliados',
    text: 'Nuestros aliados',
    image: {
      src: '/images/prima-productos/ahorroYa-banner-store-icon.svg',
      alt: 'Nuestros aliados'
    }
  },
  {
    scrollToSectionText: 'ahorroYa-questions-section',
    ahorroYaSectionBtnText: 'Preguntas frecuentes',
    text: 'Preguntas frecuentes',
    image: {
      src: '/images/prima-productos/ahorroYa-banner-questions-icon.svg',
      alt: 'Preguntas frecuentes'
    }
  },
]

const ListCard = ({ scrollToSection, AhorroYaSectionBtn }) => {
  return (
    <div className="ahorroYa-banner__list-card">
      {listCardItems.map((element) => (
        <div
          key={element.text}
          className="ahorroYa-banner__list-card__logo"
          onClick={() => {
            scrollToSection(element.scrollToSectionText)
            AhorroYaSectionBtn(element.ahorroYaSectionBtnText)
          }}
        >
          <span>{element.text}</span>
          <img
            src={withPrefix(element.image.src)}
            alt={element.image.alt}
          />
        </div>
      ))}
    </div>
  )
}

export default ListCard;
